"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.dotComCookieAllowList = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dotComCookieAllowList = ['external_referrer', 'utm_campaign', 'utm_source', 'utm_term', 'utm_medium', 'optimizelyEndUserId', 'tck'];
exports.dotComCookieAllowList = dotComCookieAllowList;

function get() {
  var dotComCookieProperties = {};

  var dotComCookie = _jsCookie.default.get(_types.COOKIE_KEYS.DOT_COM);

  if (dotComCookie) {
    try {
      var dotComCookiePropertiesFull = JSON.parse(dotComCookie);
      dotComCookieProperties = dotComCookieAllowList.reduce((acc, prop) => {
        if (dotComCookiePropertiesFull[prop]) {
          acc[prop] = dotComCookiePropertiesFull[prop];
        }

        ;
        return acc;
      }, {});
    } catch (e) {// ignore parsing error
    }
  }

  return dotComCookieProperties;
}
//# sourceMappingURL=dotComCookie.js.map